import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { plainTextToQuillHtml } from '../twoLanguage/EditorUtil';

interface PromtFormatterProps {
    value?: string;
    readOnly?: boolean;
    className?: string;
}

const PromtFormatter: React.FC<PromtFormatterProps> = ({
    value,
    readOnly = true,
    className = ''
}) => {
    const getQuillValue = (val?: string) => {
        if (!val) return '';
        if (!/^<.*?>.*<\/.*?>$/.test(val)) {
            return plainTextToQuillHtml(val);
        }
        return val;
    };

    return (
        <ReactQuill
            className={className ? className : 'custome-quill-read-only'}
            modules={{ toolbar: false }}
            readOnly={readOnly}
            value={getQuillValue(value)}
        />
    );
};

export default PromtFormatter;



// WEBPACK FOOTER //
// ./src/components/Table/components/reactQuill/PromtFormatter.tsx